export const SocialNetworks = {
    linkedin: "linkedin",
    facebook: "facebook",
    twitter: "twitter",
    instagramm: "instagramm",
    youtube: "youtube"
} as const;

export type SocialNetworks = typeof SocialNetworks[keyof typeof SocialNetworks];
